import { Injectable } from '@angular/core';

import { ConfigParserService } from './config-parser.service';

export interface UniversalStoreConfig {
    BulkLicensePreviewApiPath: string;
    CollectionsApiRoot: string;
    O365HomeProductId: string;
    O365PersonalProductId: string;
    O365SoloProductId: string;
    PerpetualSuiteIds: string;
    PerpetualSuiteIds2019: string;
    SubscriptionSuiteIds: string;
}

@Injectable({
    providedIn: 'root'
})
export class UniversalStoreConfigService {
    public readonly config: UniversalStoreConfig;

    constructor(configParserService: ConfigParserService) {
        this.config = configParserService.parse<UniversalStoreConfig>('universalStoreConfig') ||
            {
                BulkLicensePreviewApiPath: '',
                CollectionsApiRoot: '',
                O365HomeProductId: '',
                O365PersonalProductId: '',
                O365SoloProductId: '',
                PerpetualSuiteIds: '',
                PerpetualSuiteIds2019: '',
                SubscriptionSuiteIds: ''
            };
    }
}
